import React from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from 'styles/app-styles';
import {local, setlocal, clearlocal} from 'data/lib/local-json'
import Isvg from 'react-inlinesvg'
import { BugIcon } from 'images/icons/header/'

const BugTagContainer = styled.div<{visible: boolean}>`
  border: 1px solid ${Colors.colorWarning};
  border-radius: 5px;
  padding: 5px;
  user-select: none;
  color: ${Colors.colorWarning} !important;
  svg { 
    width: 15px;
    fill: ${Colors.colorWarning} !important;
  }
  ${({visible}) => visible ? '' : `
    border: 1px solid rgba(0,0,0,0);
    color: rgba(0,0,0,0) !important;
    svg { 
      width: 15px;
      fill: rgba(0,0,0,0) !important;
    }
    `}
`;

export class BugTag extends React.Component {
  static contextTypes = {
    dispatch: PropTypes.func
  }

  constructor(props){
    super(props)
    this.refreshnag()
  }

  state = {
    verbose: local('verboseValidationErrors',false)
  }

  toggleDebugger = (evt) => {
    evt.preventDefault()
    const verbose = !this.state.verbose
    setlocal('verboseValidationErrors', verbose)
    this.setState({verbose})
    if (!verbose) {
      setlocal('verbose-timeout', Date.now())
    }
  }

  refreshnag() {
    const isDev = ['localhost', 'development'].includes(process.env.SWARM_ENV)
    const timeout = local('verbose-timeout')
    const ttl = 1*24*60*60*1000
    const verbose = local('verboseValidationErrors')

    if (isDev && !verbose && (!timeout || Date.now() - timeout > ttl)) {
      setlocal('verboseValidationErrors', true)
      clearlocal('verbose-timeout')
    }
  }

  render() {
    return <BugTagContainer visible={this.state.verbose} onContextMenu={this.toggleDebugger}><Isvg src={BugIcon}></Isvg></BugTagContainer>
  }
}
